/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { SizeColumn } from '@veeam-vspc/shared/components';
import { isPositiveNumber } from '@veeam-vspc/shared/helpers';

import type { SizeColumnProps } from '@veeam-vspc/shared/components';

export interface RestorePointSizeProps extends SizeColumnProps {
}

export const RestorePointSizeColumn: React.FC<RestorePointSizeProps> = ({ value, ...restProps }) => (
    <SizeColumn
        {...restProps}
        value={isPositiveNumber(value) ? value : null}
        pointFixed={1}
    />
);
